import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { OpkraevningStateEnum } from 'src/app/api/models/OK/Egis/Service/Models/DTO/Enums/opkraevning-state-enum';

@Component({
    selector: 'app-opkraevnings-status',
    templateUrl: './opkraevnings-status.component.html',
    styleUrls: ['./opkraevnings-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OpkraevningsStatusComponent implements OnInit {
  @Input() opkraevningState: OpkraevningStateEnum;

  opkraevningStateEnum = OpkraevningStateEnum;

  constructor() {}

  ngOnInit(): void {}
}
